import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useMediaQuery,
  SelectChangeEvent,
  Select,
  MenuItem
} from "@mui/material";
import { Logout } from "@mui/icons-material";

import { memo, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import MobileMenu from "../mobile-menu/MobileMenu";

import { OverviewAccountFreyIsland, OverviewAccountMYAccountPlus } from "../utils";
import { HeaderMenuListType, Profile, Setting, toTitleCase, UserInfo } from "../../helpers";

import "./header.scss";

interface Props {
  userInfo: UserInfo;
  account: OverviewAccountFreyIsland | OverviewAccountMYAccountPlus;
  overviewAccounts: OverviewAccountFreyIsland[] | OverviewAccountMYAccountPlus[];
  user: Profile;
  setting: Setting;
  handleLogout: () => void;
  adminInfo: UserInfo;
  accountChangeHandler: (event: SelectChangeEvent) => void;
  userAccountActionsHandler: () => void;
  fif: boolean;
  navAdminItems: HeaderMenuListType[];
  navUserItems: HeaderMenuListType[];
  loginItems: HeaderMenuListType[];
  pathname: string;
}

const HeaderPanel = ({
  userInfo,
  account,
  overviewAccounts,
  user,
  setting,
  handleLogout,
  adminInfo,
  accountChangeHandler,
  userAccountActionsHandler,
  fif,
  navAdminItems,
  navUserItems,
  loginItems,
  pathname
}: Props) => {

  const navigate = useNavigate();

  const isTabletView = useMediaQuery("(max-width: 960px)");
  const isMobileView = useMediaQuery("(max-width: 640px)");

  const [selectedAccount, setSelectedAccount] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const logoutHandler = () => {
    if (sessionStorage.adminInfo) {
      setSelectedAccount("");
      setSelectedItem(null);
      handleLogout();
    } else {
      handleLogout();
    }
  };

  const onAccountChange = (event: SelectChangeEvent) => {
    setSelectedAccount(event.target.value);
    navigate("/accounts/" + event.target.value);
    accountChangeHandler(event);
  };

  const handleItemClick = (item: { name?: string; link: string }) => {
    if (item.link !== selectedItem) {
      let itemLink = item.link;
      if (isTabletView && userInfo) {
        if (userInfo.role == "User") {
          if (!item.link.includes("/profile") &&
            (fif || (item.link !== "/residential-credit" && item.link !== "/contact"))
          ) {
            // itemLink = "/accounts";
            // this is not necessary...the current account Id is maintained as state
            const accountLink =
              "/accounts/" + (account?.account_id.length > 0 ? account.account_id : overviewAccounts[0] ? overviewAccounts[0].account_id : "");
            // this is necessary for fif mobile view for navigate to different pages
            itemLink = item.name === "Overview" ? accountLink : accountLink + item.link;
          }
        }
      }
      setSelectedItem(itemLink);
      return navigate(itemLink);
    }
    return navigate(item.link);
  };

  useEffect(() => {
    if (overviewAccounts.length > 0 && pathname.split("/").length >= 2 && pathname.split("/")[2] !== account.account_id) {
      userAccountActionsHandler();
    }
  }, [overviewAccounts.length, pathname]);

  useEffect(() => {
    if (account.account_id.length > 0 && selectedAccount === "") {
      setSelectedAccount(account.account_id);
    }
  }, [account]);

  return (
    <Box className="main-header">
      {adminInfo && (
        <Box className="headerTitle" boxShadow={5}>
          <Typography className="login-as">LOGIN AS: {userInfo.impersonating}</Typography>
        </Box>
      )}
      <Box className="header-wrapper">
        <Box className="header-logo">
          <Box className="icon-wrapper">
            {setting.logo.length ? (
              <Link to={setting.full_site}>
                <img src={setting.logo} alt="logo" className="icon" />
              </Link>
            ) : (
              ""
            )}
          </Box>
          {!isMobileView && (
            <Typography variant="h6" className="site-name">
              {setting.site_name}
            </Typography>
          )}
        </Box>
        {isTabletView && userInfo ? (
          <MobileMenu
            setting={setting}
            userInfo={userInfo}
            handleItemClick={handleItemClick}
            logoutHandler={logoutHandler}
            menuItems={userInfo.role == "User" ? navUserItems : navAdminItems}
            profileAccountId={user.account_ids}
            accountId={account.account_id}
          />
        ) : (
          <List className="menu-wrapper">
            {(userInfo ? (userInfo.role === "User" ? navUserItems : navAdminItems) : loginItems).map((item) => (
              <ListItem key={item.name} disablePadding>
                <ListItemButton
                  className={`list-item-button ${pathname.includes(item.link) ? "active" : ""}`}
                  onClick={() => handleItemClick(item)}
                  selected={selectedItem === item.link}
                >
                  {item.icon}
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            ))}
            {userInfo && (
              <ListItem disablePadding>
                <ListItemButton className="list-item-button" onClick={logoutHandler}>
                  <Logout />
                  <ListItemText primary="Logout" />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        )}
        {/*{isTabletView && userInfo && userInfo.role === "User" && pathname.includes("/accounts") && (*/}
        {/*  <Box className="select-wrapper">*/}
        {/*    <Select*/}
        {/*      name="accounts"*/}
        {/*      fullWidth*/}
        {/*      value={selectedAccount || ""}*/}
        {/*      onChange={onAccountChange}*/}
        {/*      className={selectedAccount.length > 0 ? "MuiCustom-success" : ""}*/}
        {/*    >*/}
        {/*      {overviewAccounts.map((item: OverviewAccountMYAccountPlus | OverviewAccountFreyIsland) => {*/}
        {/*        return (*/}
        {/*          <MenuItem key={item.account_id} value={item.account_id}>*/}
        {/*            {item.account_id + " - " + toTitleCase(item.display_name ? item.display_name : item?.account_name ?? "")}*/}
        {/*          </MenuItem>*/}
        {/*        );*/}
        {/*      })}*/}
        {/*    </Select>*/}
        {/*  </Box>*/}
        {/*)}*/}
      </Box>
    </Box>
  );
};

export default memo(HeaderPanel);
